const defaultState = {
  sidebarLocked: false,
  insightsMode: "channel", // ["channel", "domain"]
  options: {
    campaignFilterPersonal: "company", // ["company", "creator"]
  },
  plansInProgress: [], // Plans (scheme) that are waiting the content to be inserted with cron-job
  unreadMessages: 0,
  unreadNotifications: 0,
  user: {
    id: null,
    username: null,
    firstName: "",
    lastName: "",
    email: null,
    image: null,
  },
  companies: [],
  storeLang: "sv", // Language of store categories (this is separate from coach system language)
  selectedChannel: {},

  auth: {
    logged: false,
    accessToken: null,
    refreshToken: null,
    expireTime: null,
    tokenType: null,
  },
  brpLocation: {
    id: null,
    name: null,
    slug: null,
  },
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case "SIDEBAR_TOGGLE":
      return {
        ...state,
        sidebarLocked: action.payload,
      };
    case "LOGIN":
      return {
        ...state,
        auth: action.payload,
      };
 
  
      
  case "LOGOUT":
      return {
        ...defaultState,
        // Need to reset everything here when logging out
        brpLocation: {
          id: null,
          name: null,
          slug: null,
        },
      };
    case "SET_BRP_LOCATION":
      return {
        ...state,
        brpLocation: {
          ...state.brpLocation,
          ...action.payload,
        },
      };
    case "SET_COMPANIES":
      return {
        ...state,
        companies: action.payload.list,
        selectedChannel: action.payload.selected,
      };
    case "SELECT_CHANNEL":
      return {
        ...state,
        selectedChannel: action.payload || {},
        insightsMode: "channel",
      };
    case "SET_USER":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    case "SET_INSIGHTS":
      return {
        ...state,
        insightsMode: action.payload,
      };
    case "SET_UNREAD_NOTIFICATIONS":
      return {
        ...state,
        unreadNotifications: action.payload,
      };
    case "SET_UNREAD_MESSAGES":
      return {
        ...state,
        unreadMessages: action.payload,
      };
    case "SET_CAMPAIGN_FILTER_PERSONAL":
      return {
        ...state,
        options: {
          ...state.options,
          campaignFilterPersonal: action.payload,
        },
      };
    case "SET_UNREADS":
      return {
        ...state,
        unreadMessages: action.payload.unreadMessages,
        unreadNotifications: action.payload.unreadNotifications,
      };
    case "SET_WAITING_PLAN":
      return {
        ...state,
        plansInProgress: [...state.plansInProgress, action.payload],
      };
    case "DELETE_WAITING_PLAN":
      return {
        ...state,
        plansInProgress: state.plansInProgress.filter(
          (p) => p != action.payload
        ),
      };
    case "STORE_LANG_TOGGLE":
      return {
        ...state,
        storeLang: state.storeLang === "sv" ? "en" : "sv",
      };
    default:
      return state;
  }
}
